import { useLocation } from 'react-router-dom';

import { Box, Typography, useTheme } from '@mui/material';
import { CustomAppBar } from 'theme/layouts/navbar';
import { pagesEnum } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { getDir, selectTranslations } from 'state/reducers/translation.reducers';
import _ from 'lodash';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export default function MobileNavbar(props: {
	handleBack: any;
	handleCancel?: any;
	noCancel?: boolean;
	label?: string;
	cancelLabel?: string;
}) {
	const theme = useTheme();
	const dir = useAppSelector(getDir);
	const t = useAppSelector(selectTranslations);
	const location = useLocation();
	const path = location.pathname.replace(/\/\d+$/, '');
	const beneficiaryUrl = `/${pagesEnum.BENEFICIARY}/`;
	const getTitle = () => {
		switch (path) {
			case beneficiaryUrl + 'edit':
				return 'page.beneficiary.edit.header.title';
			case beneficiaryUrl + 'new':
				return 'page.beneficiary.create.header.title';
			case beneficiaryUrl + 'details':
				return 'page.beneficiary.profile.beneficiary_details.title';
			case `/${pagesEnum.BALANCE}`:
				return 'page.balance.add.header.title';
			case `/${pagesEnum.PAY}/new`:
				return 'page.pay.create.header.title';
			case `/${pagesEnum.CONVERT}/new`:
				return 'page.convert.create.header.title';
			case `/${pagesEnum.SETTINGS}/addBankAccount`:
				return 'page.settings.bank_accounts.create.title';
			case `/${pagesEnum.SETTINGS}/editProfile/Name`:
				return 'page.settings.form.title.personal_info';
			case `/${pagesEnum.SETTINGS}/editProfile/Language`:
				return 'page.settings.form.title.language';
			case `/${pagesEnum.SETTINGS}/reviewPlanChange`:
				return 'page.settings.review_new_plan.new_plan';
			case `/${pagesEnum.ACTIVITY}/profile/withdrawal`:
				return 'page.activity.table.type.withdrawal.text';
			case `/${pagesEnum.CONVERT}/profile`:
				return 'page.activity.table.type.conversion_activities.text';
			case `/${pagesEnum.PAY}/profile`:
				return 'page.activity.table.type.payment_activities.text';
			case `/${pagesEnum.REFUND}/profile`:
				return 'page.activity.table.type.refund_activities.text';
			case `/${pagesEnum.ACTIVITY}/profile/topping`:
				return 'page.activity.table.type.balance_activities.text';
			case `/${pagesEnum.REQUEST}/requestDetailsPY`:
				return 'page.activity.table.type.payment_activities.text';
		}
		return props.label || 'null';
	};
	const prop = {
		onClick: props.handleBack,
		sx: {
			color: '#000',
			cursor: 'pointer',
			width: '16px',
			transform: dir === 'rtl' ? 'scaleX(-1)' : '',
		},
	};
	const cancelProps = {
		component: 'div',
		color: 'rgb(44 62 80)',
	};
	return (
		<CustomAppBar
			open={false}
			sx={{ justifyContent: 'space-between', left: 0, [theme.breakpoints.up('sm')]: { display: 'none' } }}
		>
			<ArrowBackIosIcon width={'16px'} {...prop} />
			<Typography
				variant="boldBody18"
				sx={{
					color: theme.palette.root.basicDeeoGreen,
					position: 'absolute',
					left: 0,
					textAlign: 'center',
					width: '100%',
					zIndex: -1,
				}}
			>
				{t(getTitle())}
			</Typography>
			{props.noCancel ? (
				<></>
			) : (
				<Typography {...cancelProps} onClick={() => props.handleCancel()}>
					{props.cancelLabel || 'Cancel'}
				</Typography>
			)}
		</CustomAppBar>
	);
}
